/* =============================================================
   arije — Fiche produit
   Vanilla JS, aucune dépendance.
   ============================================================= */
(function () {
  'use strict';
  if (window.__arijeProduit) return;
  window.__arijeProduit = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  /* ---------------------------------------------------------
     Galerie — carrousel réellement infini.

     Technique : on clone la dernière image AVANT la première et
     la première APRÈS la dernière. Le passage 7 -> 1 devient donc
     un simple pas vers la droite (animé) ; une fois l'animation
     terminée on repositionne le conteneur sans animation sur la
     vraie première image. La bascule est invisible.
     --------------------------------------------------------- */
  class ArijeGallery extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;

      this.list = this.querySelector('.pg__list');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.pg__item'));
      this.counter = this.querySelector('.pg__counter');
      this.dots = this.querySelector('.pg__dots');
      this.prev = this.querySelector('.pg__nav--prev');
      this.next = this.querySelector('.pg__nav--next');
      this.index = 0;
      this.busy = false;
      if (!this.list || !this.items.length) return;

      this.buildLoop();
      this.buildDots();
      this.buildNav();
      this.watchScroll();

      var self = this;
      var featured = this.querySelector('.pg__item.is-featured:not(.pg__item--clone)');
      var start = featured ? this.items.indexOf(featured) : 0;
      requestAnimationFrame(function () { self.jumpTo(start < 0 ? 0 : start); });

      window.addEventListener('resize', debounce(function () { self.jumpTo(self.index); }, 200));
    }

    buildLoop() {
      this.loop = this.items.length > 1;
      if (!this.loop) return;
      var n = this.items.length;
      var head = this.items[n - 1].cloneNode(true);
      var tail = this.items[0].cloneNode(true);
      [head, tail].forEach(function (c) {
        c.classList.add('pg__item--clone');
        c.classList.remove('is-featured');
        c.removeAttribute('id');
        c.removeAttribute('data-media-id');
        c.removeAttribute('data-index');
        c.setAttribute('aria-hidden', 'true');
      });
      this.list.insertBefore(head, this.list.firstChild);
      this.list.appendChild(tail);
    }

    slideWidth() { return this.list.clientWidth || 1; }
    rawOf(i) { return this.loop ? i + 1 : i; }

    jumpTo(i) {
      this.list.style.scrollBehavior = 'auto';
      this.list.scrollLeft = this.rawOf(i) * this.slideWidth();
      this.list.style.scrollBehavior = '';
      this.setIndex(i);
    }

    slideTo(i) {
      if (this.busy) return;
      this.animateToRaw(this.rawOf(i));
      this.setIndex(i);
    }

    animateToRaw(raw, done) {
      var self = this;
      this.busy = true;
      this.list.scrollTo({
        left: raw * this.slideWidth(),
        behavior: REDUCED ? 'auto' : 'smooth'
      });
      this.afterScroll(function () {
        self.busy = false;
        if (done) done();
      });
    }

    afterScroll(cb) {
      var self = this;
      var fired = false;
      function fin() {
        if (fired) return;
        fired = true;
        clearTimeout(timer);
        self.list.removeEventListener('scrollend', fin);
        cb();
      }
      var timer = setTimeout(fin, REDUCED ? 30 : 700);
      if ('onscrollend' in window) this.list.addEventListener('scrollend', fin);
    }

    go(dir) {
      if (this.busy) return;
      var self = this;
      var n = this.items.length;
      var to = this.index + dir;

      if (!this.loop) {
        this.slideTo(Math.max(0, Math.min(n - 1, to)));
        return;
      }

      if (to < 0) {
        this.setIndex(n - 1);
        this.animateToRaw(0, function () { self.jumpTo(n - 1); });
      } else if (to > n - 1) {
        this.setIndex(0);
        this.animateToRaw(n + 1, function () { self.jumpTo(0); });
      } else {
        this.slideTo(to);
      }
    }

    watchScroll() {
      var self = this;
      var ticking = false;
      this.list.addEventListener('scroll', function () {
        if (ticking || self.busy) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var n = self.items.length;
          var raw = Math.round(self.list.scrollLeft / self.slideWidth());
          if (!self.loop) { self.setIndex(Math.max(0, Math.min(n - 1, raw))); return; }
          if (raw === 0) { self.setIndex(n - 1); self.jumpTo(n - 1); return; }
          if (raw === n + 1) { self.setIndex(0); self.jumpTo(0); return; }
          self.setIndex(raw - 1);
        });
      }, { passive: true });
    }

    buildDots() {
      if (!this.dots) return;
      var self = this;
      this.dots.innerHTML = '';
      this.items.forEach(function (item, i) {
        var b = document.createElement('button');
        b.className = 'pg__dot';
        b.type = 'button';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', 'Visuel ' + (i + 1));
        b.addEventListener('click', function () { self.slideTo(i); });
        self.dots.appendChild(b);
      });
      this.dotEls = Array.prototype.slice.call(this.dots.children);
    }

    buildNav() {
      var self = this;
      var single = this.items.length < 2;
      [this.prev, this.next].forEach(function (b) { if (b) b.hidden = single; });
      if (single) return;
      if (this.prev) this.prev.addEventListener('click', function () { self.go(-1); });
      if (this.next) this.next.addEventListener('click', function () { self.go(1); });
    }

    setIndex(i) {
      this.index = i;
      if (this.counter) this.counter.textContent = pad(i + 1) + ' / ' + pad(this.items.length);
      if (this.dotEls) {
        this.dotEls.forEach(function (d, n) { d.setAttribute('aria-selected', n === i ? 'true' : 'false'); });
      }
    }

    setActiveMedia(mediaId) {
      var target = this.querySelector('.pg__item:not(.pg__item--clone)[data-media-id="' + mediaId + '"]');
      if (!target) return;
      var i = this.items.indexOf(target);
      if (i > -1) this.slideTo(i);
    }
  }

  if (!customElements.get('arije-gallery')) {
    customElements.define('arije-gallery', ArijeGallery);
  }

  /* ---------------------------------------------------------
     Barre d'achat flottante
     --------------------------------------------------------- */
  function initBuyBar() {
    if (document.querySelector('.pa-bar')) return;

    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var submit = info.querySelector('[name="add"], .product-form__submit');
    if (!submit) return;

    var titleEl = info.querySelector('.product__title h1, .product__title, h1');
    var priceEl = info.querySelector('.price');
    var thumb = document.querySelector('.pg__item:not(.pg__item--clone) .pg__frame img');

    /* Le bloc prix contient des libellés réservés aux lecteurs d'écran
       (Prix habituel, Prix promotionnel, Prix unitaire). On isole le
       montant affiché et on retire ces libellés. */
    function readPrice() {
      if (!priceEl) return '';
      var onSale = priceEl.classList.contains('price--on-sale');
      var el =
        priceEl.querySelector(onSale ? '.price-item--sale' : '.price__regular .price-item--regular') ||
        priceEl.querySelector('.price-item--sale') ||
        priceEl.querySelector('.price-item--regular') ||
        priceEl.querySelector('.price-item');
      if (!el) return '';
      var c = el.cloneNode(true);
      Array.prototype.forEach.call(
        c.querySelectorAll('.visually-hidden, .visually-hidden--inline'),
        function (n) { n.remove(); }
      );
      return c.textContent.replace(/\s+/g, ' ').trim();
    }

    var bar = document.createElement('div');
    bar.className = 'pa-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Achat rapide');

    var html = '';
    if (thumb) html += '<div class="pa-bar__thumb"><img src="' + thumb.currentSrc + '" alt="" loading="lazy"></div>';
    html += '<div class="pa-bar__text">';
    html += '<span class="pa-bar__title">' + (titleEl ? titleEl.textContent.trim() : '') + '</span>';
    html += '<span class="pa-bar__price"></span>';
    html += '</div>';
    html += '<button type="button" class="button pa-bar__cta"></button>';
    bar.innerHTML = html;
    document.body.appendChild(bar);

    var barPrice = bar.querySelector('.pa-bar__price');
    var barCta = bar.querySelector('.pa-bar__cta');

    function sync() {
      if (barPrice) barPrice.textContent = readPrice();
      barCta.textContent = (submit.textContent || 'Ajouter au panier').replace(/\s+/g, ' ').trim();
      barCta.disabled = submit.disabled;
    }
    sync();

    barCta.addEventListener('click', function () { submit.click(); });

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      if (priceEl) mo.observe(priceEl, { childList: true, subtree: true, characterData: true });
      mo.observe(submit, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', passed);
      });
    }, { threshold: 0 });
    io.observe(submit);
  }

  /* ---------------------------------------------------------
     Drive to store : Trouver en boutique à côté du CTA
     --------------------------------------------------------- */
  function initCtaRow() {
    var submit = document.querySelector('.product__info-container .product-form__buttons .product-form__submit');
    if (!submit || submit.closest('.pa-cta-row')) return;

    var row = document.createElement('div');
    row.className = 'pa-cta-row';
    submit.parentNode.insertBefore(row, submit);
    row.appendChild(submit);

    var find = document.getElementById('find-in-store-btn');
    if (!find) return;
    var li = find.closest('li');
    find.className = 'pa-find';
    row.appendChild(find);
    if (li && !li.children.length && !li.textContent.trim()) li.remove();
  }

  /* ---------------------------------------------------------
     Caractéristiques
     --------------------------------------------------------- */
  function initSpecs(root) {
    var blocks = (root || document).querySelectorAll('.ps:not([data-pa-ready])');
    Array.prototype.forEach.call(blocks, function (ps) {
      ps.setAttribute('data-pa-ready', '');

      var rows = ps.querySelectorAll('.ps__row');
      Array.prototype.forEach.call(rows, function (r, i) {
        r.style.setProperty('--pa-delay', Math.min(i, 12) * 55 + 'ms');
      });

      var more = ps.querySelector('.ps__more');
      if (more) {
        more.addEventListener('click', function () {
          var open = ps.classList.toggle('is-open');
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      if (REDUCED || !('IntersectionObserver' in window)) { ps.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
      io.observe(ps);
    });
  }

  /* ---------------------------------------------------------
     Manifeste
     --------------------------------------------------------- */
  function initManifeste(root) {
    var blocks = (root || document).querySelectorAll('.pm:not([data-pa-ready])');
    Array.prototype.forEach.call(blocks, function (pm) {
      pm.setAttribute('data-pa-ready', '');
      if (REDUCED || !('IntersectionObserver' in window)) { pm.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      io.observe(pm);
    });
  }

  /* ---------------------------------------------------------
     Boot
     --------------------------------------------------------- */
  function init(root) {
    initSpecs(root);
    initManifeste(root);
    initCtaRow();
    initBuyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.ArijeProduit = { init: init };
})();
